var $6f40c3a58f594b58$exports = {};
const $6f40c3a58f594b58$var$API_KEY = '54251385-6f7a6e7accba74a4972a9b1fa';
const $6f40c3a58f594b58$var$BASE_URL = 'https://pixabay.com/api/';
const $6f40c3a58f594b58$var$form = document.getElementById('search-form');
const $6f40c3a58f594b58$var$gallery = document.querySelector('.gallery');
const $6f40c3a58f594b58$var$loadMoreBtn = document.querySelector('.load-more');
let $6f40c3a58f594b58$var$searchQuery = '';
let $6f40c3a58f594b58$var$page = 1;
const $6f40c3a58f594b58$var$perPage = 12;
let $6f40c3a58f594b58$var$totalHits = 0;
$6f40c3a58f594b58$var$loadMoreBtn.classList.add('hidden');
$6f40c3a58f594b58$var$form.addEventListener('submit', async (e)=>{
    e.preventDefault();
    $6f40c3a58f594b58$var$searchQuery = e.target.elements.query.value.trim();
    if (!$6f40c3a58f594b58$var$searchQuery) return;
    $6f40c3a58f594b58$var$page = 1;
    $6f40c3a58f594b58$var$gallery.innerHTML = '';
    $6f40c3a58f594b58$var$loadMoreBtn.classList.add('hidden');
    await $6f40c3a58f594b58$var$fetchImages();
});
$6f40c3a58f594b58$var$loadMoreBtn.addEventListener('click', async ()=>{
    $6f40c3a58f594b58$var$page += 1;
    await $6f40c3a58f594b58$var$fetchImages();
});
async function $6f40c3a58f594b58$var$fetchImages() {
    try {
        const response = await fetch(`${$6f40c3a58f594b58$var$BASE_URL}?key=${$6f40c3a58f594b58$var$API_KEY}&q=${$6f40c3a58f594b58$var$searchQuery}&image_type=photo&orientation=horizontal&page=${$6f40c3a58f594b58$var$page}&per_page=${$6f40c3a58f594b58$var$perPage}`);
        if (!response.ok) throw new Error("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F");
        const data = await response.json();
        $6f40c3a58f594b58$var$totalHits = data.totalHits;
        if ($6f40c3a58f594b58$var$page === 1 && data.hits.length === 0) {
            PNotify.alert({
                text: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
                type: "\u043F\u043E\u043C\u0438\u043B\u043A\u0430"
            });
            return;
        }
        $6f40c3a58f594b58$var$renderImages(data.hits);
        if ($6f40c3a58f594b58$var$page === 1) PNotify.alert({
            text: `\u{437}\u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43E} ${$6f40c3a58f594b58$var$totalHits} \u{43A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43E}\u{43A}`,
            type: "\u0443\u0441\u043F\u0456\u0445"
        });
        if ($6f40c3a58f594b58$var$page * $6f40c3a58f594b58$var$perPage < $6f40c3a58f594b58$var$totalHits) $6f40c3a58f594b58$var$loadMoreBtn.classList.remove('hidden');
        else {
            $6f40c3a58f594b58$var$loadMoreBtn.classList.add('hidden');
            PNotify.alert({
                text: "\u043A\u0456\u043D\u0435\u0446\u044C",
                type: "\u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F"
            });
        }
        $6f40c3a58f594b58$var$smoothScroll();
    } catch (error) {
        PNotify.alert({
            text: "\u0429\u043E\u0441\u044C \u043D\u0435 \u0442\u0430\u043A",
            type: "\u043F\u043E\u043C\u0438\u043B\u043A\u0430"
        });
    }
}
function $6f40c3a58f594b58$var$renderImages(images) {
    const markup = images.map((image)=>`
    <li>
      <div class="photo-card">
        <img 
          src="${image.webformatURL}" 
          data-large="${image.largeImageURL}"
          alt="${image.tags}" 
        />

        <div class="stats">
          <p class="stats-item">
            <i class="material-icons">thumb_up</i>
            ${image.likes}
          </p>
          <p class="stats-item">
            <i class="material-icons">visibility</i>
            ${image.views}
          </p>
          <p class="stats-item">
            <i class="material-icons">comment</i>
            ${image.comments}
          </p>
          <p class="stats-item">
            <i class="material-icons">cloud_download</i>
            ${image.downloads}
          </p>
        </div>
      </div>
    </li>
  `).join('');
    $6f40c3a58f594b58$var$gallery.insertAdjacentHTML('beforeend', markup);
}
function $6f40c3a58f594b58$var$smoothScroll() {
    const firstCard = $6f40c3a58f594b58$var$gallery.firstElementChild;
    if (!firstCard) return;
    const { height: cardHeight } = firstCard.getBoundingClientRect();
    window.scrollBy({
        top: cardHeight * 2,
        behavior: 'smooth'
    });
}
$6f40c3a58f594b58$var$gallery.addEventListener('click', (e)=>{
    if (e.target.nodeName !== 'IMG') return;
    const largeImage = e.target.dataset.large;
    const instance = basicLightbox.create(`
    <img src="${largeImage}" width="100%">
  `);
    instance.show();
});


//# sourceMappingURL=mini-project-hww-20.8c3d934d.js.map
